import { render } from "./TempWidgetBed.vue?vue&type=template&id=75603f37&scoped=true"
import script from "./TempWidgetBed.vue?vue&type=script&lang=js"
export * from "./TempWidgetBed.vue?vue&type=script&lang=js"

import "./TempWidgetBed.vue?vue&type=style&index=0&id=75603f37&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-75603f37"

export default script